import React from 'react';
import MainCard from '../../../components/MainCard';

/**
 * WidgetCard
 * A small wrapper around `MainCard` with commonly used styles for dashboard widgets.
 * Props:
 *  - children: node
 *  - sx: additional style overrides (MUI sx)
 *  - ...rest: passed to MainCard
 */
const WidgetCard = ({ children, sx = {}, ...rest }) => {
    const baseSx = { p: 2, position: 'relative', overflow: 'visible', borderRadius: 6 };
    return (
        <MainCard sx={{ ...baseSx, ...sx }} {...rest}>
            {children}
        </MainCard>
    );
};

export default WidgetCard;
